import React from 'react';

export default function Header() {
  return (
    <header className="flex-shrink-0 bg-red-700 flex-col p-1  h-auto w-full flex justify-center items-center">
      <h1 className=" text-white font-bold text-2xl">Joshua Rieth</h1>
      <p className="text-red-100 font-semibold text-sm">
        Full Stack Developer &bull; Computer Science
      </p>
    </header>
  );
}
